import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";

interface RankMeterProps {
  rank?: "Unranked" | "Bronze" | "Silver" | "Gold" | null;
  score?: number | null;
}

export function RankMeter({ score, rank }: RankMeterProps) {
  return (
    <RankMeterContainer>
      <div className={`fill ${rank}`} style={{ width: `${score}%` }}>
        {score}%
      </div>
      <div className="bronze-cut" />
      <div className="silver-cut" />
      <div className="gold-cut" />
    </RankMeterContainer>
  );
}

const RankMeterContainer = styled(Box)`
  position: relative;
  height: 42px;
  border-radius: 100px;
  background-color: #f4f6fc;
  width: 100%;

  .fill {
    height: 42px;
    padding: 10px 16px;
    font-weight: 600;
    color: white;
    border-radius: 100px;
  }

  .fill.Gold {
    background:
      linear-gradient(
        90deg,
        rgba(220, 170, 9, 0.8) 7%,
        rgba(255, 255, 255, 0) 34%
      ),
      linear-gradient(
        93deg,
        rgba(255, 255, 255, 0) 1.98%,
        rgba(255, 255, 255, 0.18) 24.83%,
        rgba(255, 255, 255, 0.3) 38.9%,
        rgba(255, 255, 255, 0) 60.58%
      ),
      linear-gradient(180deg, #fbc110 6.33%, #f6d215 57.59%, #e5a405 108.86%);
    background-blend-mode: normal, soft-light, normal;
    box-shadow:
      0px 4px 7px 1px rgba(209, 154, 14, 0.2),
      0px 3px 0px 0px #ffd98c inset;
  }
  .fill.Silver {
    background:
      linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.2) 8.4%,
        rgba(255, 255, 255, 0) 20.39%
      ),
      linear-gradient(
        93deg,
        rgba(255, 255, 255, 0) 1.98%,
        rgba(255, 255, 255, 0.42) 24.83%,
        rgba(255, 255, 255, 0.7) 38.9%,
        rgba(255, 255, 255, 0) 60.58%
      ),
      linear-gradient(180deg, #a4a4a4 6.33%, #cfcfcf 57.59%, #c4c4c4 108.86%);
    background-blend-mode: normal, soft-light, normal;
    box-shadow:
      0px 4px 7px 1px rgba(155, 155, 155, 0.2),
      0px 3px 0px 0px #cecece inset;
  }
  .fill.Bronze {
    background:
      linear-gradient(
        90deg,
        #c4592b 9.5%,
        rgba(255, 255, 255, 0) 30.5%,
        rgba(255, 255, 255, 0) 100%
      ),
      linear-gradient(
        93deg,
        rgba(255, 255, 255, 0) 1.98%,
        rgba(255, 255, 255, 0.42) 24.83%,
        rgba(255, 255, 255, 0.7) 38.9%,
        rgba(255, 255, 255, 0) 60.58%
      ),
      linear-gradient(180deg, #d2673b 6.33%, #ef905b 108.86%);
    background-blend-mode: normal, soft-light, normal;
    box-shadow:
      0px 4px 7px 1px rgba(163, 103, 75, 0.2),
      0px 3px 0px 0px #f3a059 inset;
  }
  .fill.Unranked {
    background: linear-gradient(135deg, #f4f6fc 0%, #e6e9f2 50%, #d8dce8 100%);
    box-shadow:
      0px 2px 4px rgba(0, 0, 0, 0.1),
      0px 1px 0px 0px rgba(255, 255, 255, 0.5) inset;
    color: #000;
  }

  .bronze-cut,
  .silver-cut,
  .gold-cut {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #d5d8e1;
  }
  .bronze-cut {
    left: 50%;
  }
  .silver-cut {
    left: 75%;
  }
  .gold-cut {
    left: 90%;
  }
`;
